import { register as registerSubscription } from '@ms/yammer-data/dist/domains/pushSubscriptions/actions';
import { subscribe, unsubscribe } from '@ms/yammer-web-support/dist/pushNotifications';
import type { MutableRefObject } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useGetPushSubscriptionServerKey } from '../pushSubscriptionServerKey';

export const useRegisterPushSubscriptionCallback = (
  subscription: MutableRefObject<PushSubscription | null | undefined>
): (() => Promise<void>) => {
  const dispatch = useDispatch();

  const applicationServerKey = useGetPushSubscriptionServerKey();

  return useCallback(async () => {
    if (subscription.current == null || !applicationServerKey) {
      return;
    }

    await unsubscribe(subscription.current);
    const result = await subscribe(applicationServerKey);
    if (!result) {
      return;
    }

    // eslint-disable-next-line react-hooks/immutability
    subscription.current = result;
    await dispatch(registerSubscription(subscription.current, applicationServerKey));
  }, [subscription, dispatch, applicationServerKey]);
};
